// src/store/actions.js
export default {
    // 登录操作
    login({ commit }, loginForm) {
        return new Promise((resolve, reject) => {
            // 模拟登录API调用
            setTimeout(() => {
                // 模拟不同用户的角色和权限
                let role = 'user';
                let permissions = ['project:view'];
                
                if (loginForm.username === '管理员') {
                    role = 'admin';
                    permissions = ['home:view', 'project:view', 'summary:view','manager:view', 'setting:view'];
                } else if (loginForm.username === '项目经理') {
                    role = 'manager';
                    permissions = ['project:view','home:view'];
                } else if (loginForm.username === '李华富') {
                    role = 'manager';
                    permissions = ['project:view','home:view', 'project:GC-2026-001'];
                }
                else if (loginForm.username === '普通用户') {
                    role = 'user';
                    permissions = ['home:view'];
                }
                
                const userInfo = {
                    userid: '1',
                    username: loginForm.username,
                    userposition: role ,
                    role,
                    permissions
                };
                
                commit('setUserInfo', userInfo);
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                resolve(userInfo);
            }, 1000);
        });
    },
    // 登出操作
    logout({ commit }) {
        commit('clearUserInfo');
    }
}